import React, { FC, lazy, Suspense } from 'react';
import { ReactPlayableProps } from 'react-playable';
import { FullHeightLoader } from '../FullHeightLoader';
import styles from './VideoPlayer.scss';

const LazyReactPlayable = lazy(() =>
  import(/* webpackChunkName: 'video-player' */ 'react-playable').then(({ ReactPlayable }) => ({
    default: ReactPlayable,
  })),
);

export const VideoPlayer: FC<ReactPlayableProps> = (props) => (
  <Suspense
    fallback={
      <div className={styles.preloaderWrapper}>
        <FullHeightLoader size="small" />
      </div>
    }
  >
    <LazyReactPlayable {...props} />
  </Suspense>
);
